import { Suspense, lazy } from 'react';
import { Canvas } from '@react-three/fiber';
import { Scene, LazyPriority } from './Scene';
import DelayedComponent from 'app/components/common/lazy/delayed';

const HomeExpEditorControls = lazy(() => import('./editor/controls'));

export const ExperiencesThreeAnimation = (props: { active?: boolean, bgColor?: boolean, controls?: boolean }) => {

    return (
        <Suspense fallback={null}>
            <Canvas id="home-experiences-3d" flat linear>
                <DelayedComponent lazyPriority={LazyPriority - 1}>
                    <Scene
                        visible={props.active}
                        bgColor={props.bgColor}
                    />
                </DelayedComponent>
            </Canvas>
            {props.controls && import.meta.env.PUBLIC_APP_ENV !== 'production' && (
                <HomeExpEditorControls />
            )}
        </Suspense>
    );
};
